import Delegate from 'ftdomdelegate'
import { gsap, Cubic, Quad } from 'gsap'

import Carousel from "../components/carousel";
import Responsive from "../tools/responsive";
import Dom from "../tools/dom";

export default class SlideshowSection {
  constructor(container) {
  
    this.element = container;
    this.delegateElement = new Delegate(this.element);
    this.slideshow = new Carousel(this.element.querySelector('[data-flickity-config]'), { 
      onSelect: this._onSlideChanged.bind(this) 
    });
    this.selectedSlide = null;
    this.shouldAnimate = true;
    this.timeline = gsap.timeline({ delay: window.theme.showPageTransition ? 0.5 : 0 })

    if (this.slideshow.flickityInstance.cells.length > 0) {
      this._transitionToSlide(this.slideshow.flickityInstance.selectedCell.element, true);
    }

    let allh1 = this.element.querySelectorAll('.h1');
    if (window.innerWidth < 768) {
      allh1.forEach((item)=>{
        let txt = item.querySelector('.block');
        let charac = txt.innerHTML.length;
        if(charac > 25){
          item.style.fontSize = '36px';
        }
      })      
    }
    this._attachListeners();
  }

  onUnload() {
    this.slideshow.destroy();
    this.timeline.kill();
    this.delegateElement.off();

    document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);
  }
  onBlockSelect(event) {
    if (this.slideshow.flickityInstance.options.autoPlay) {
      this.slideshow.flickityInstance.stopPlayer();
    }

    this.shouldAnimate = !event.detail.load;
    this.slideshow.selectCell(event.target.getAttribute('data-slide-index'), false, !event.detail.load);
  }
  onBlockDeselect() {
    this.shouldAnimate = true;

    if (this.slideshow.flickityInstance.options.autoPlay) {
      this.slideshow.flickityInstance.playPlayer();
    }
  }
  _attachListeners() {
    this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this);
    this._resize = this._resize.bind(this);
    this.delegateElement.on('mouseenter', '.button', this._pauseSlideshow.bind(this), true);
    this.delegateElement.on('mouseleave', '.button', this._resumeSlideshow.bind(this), true);
    document.addEventListener('resize', this._resize);
    document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);
  }
  _pauseSlideshow() {
    if (this.slideshow.flickityInstance.options.autoPlay) {
      this.slideshow.flickityInstance.pausePlayer();
    }
  }
  _resize(){
    console.log('Resized?');
  }
  _resumeSlideshow() {
    if (this.slideshow.flickityInstance.options.autoPlay) {
      this.slideshow.flickityInstance.unpausePlayer();
    }
  }
  _onSlideChanged(index, element) {
    this._transitionToSlide(element);
    var contentPosition = this.slideshow.element.querySelector('.is-selected .slideshow__content');
    if(!this.slideshow.element.classList.contains('slideshow__carousel--alt')){
      if(contentPosition.classList.contains('slideshow__content--bottomLeft')){
        setTimeout(() => {
          this.slideshow.element.classList.add('bottomLeft');
          this.slideshow.element.classList.remove('bottomRight');
          this.slideshow.element.classList.remove('bottomCenter');
        }, 350);
      }
      else if(contentPosition.classList.contains('slideshow__content--bottomCenter')){
        setTimeout(() => {
          this.slideshow.element.classList.add('bottomCenter');
          this.slideshow.element.classList.remove('bottomLeft');
          this.slideshow.element.classList.remove('bottomRight');
        }, 350);
      }
      else if(contentPosition.classList.contains('slideshow__content--bottomRight')){
        setTimeout(() => {
          this.slideshow.element.classList.add('bottomRight');
          this.slideshow.element.classList.remove('bottomLeft');
          this.slideshow.element.classList.remove('bottomCenter');
        }, 350);
      }
    }
  }
  _transitionToSlide(slide) {
    var _this64 = this;

    this.timeline.clear();

    // First, we check if there is a previous slide selected, if that's the case
    if (this.selectedSlide) {
      this._slideLeave(this.selectedSlide);
      // this.timeline.addLabel('enter', this.shouldAnimate ? '-=0.4' : 0);
      this.timeline.addLabel('enter', this.shouldAnimate ? '0' : 0);
    }

    // We get the next slide (if any) to preload it
    this._lazyLoadNextImage();

    this.timeline.fromTo(slide, this.selectedSlide && this.shouldAnimate ? 0.3 : 0, { autoAlpha: 0 }, { autoAlpha: 1, ease: Cubic.easeInOut }, 'enter');

    // The image may take 1s or more to load depending on the network, so we make sure to pause the player, and restart it once it has transitioned
    if (this.slideshow.flickityInstance.options.autoPlay && this.slideshow.flickityInstance.player.state === 'playing') {
      this.slideshow.flickityInstance.pausePlayer();
    }

    Dom.nodeListToArray(slide.querySelectorAll('.slideshow__image')).forEach(function (image) {

        _this64._slideEnter(slide);
      
    });

    this.selectedSlide = slide;
  }
  _slideLeave(slide) {
    let contentSlide = slide.querySelectorAll('.sectionHeader__subHeading span'),
        contentFade = slide.querySelectorAll('.sectionHeader__heading'),
        buttonWrapper = slide.querySelector('.sectionHeader__buttonWrapper'),
        images = slide.querySelectorAll('.slideshow__image')
        ;


    if (window.CSS && window.CSS.supports('(object-fit: cover) or (-o-object-fit: cover)')) {
      if (window.theme.showImageZooming) {
        this.timeline.fromTo(images, this.shouldAnimate ? 0.2 : 0, { opacity: 1 }, { opacity: 0, ease: Quad.easeOut }, 'enter');
      } else {
        this.timeline.fromTo(images, this.shouldAnimate ? 0.2 : 0, { opacity: 1 }, { opacity: 0, ease: Quad.easeOut }, 'enter');
      }
    }
    this.timeline.fromTo(slide, this.shouldAnimate ? 0.3 : 0, { autoAlpha: 1 }, { autoAlpha: 0, ease: Cubic.easeInOut, delay: this.shouldAnimate ? 0.35 : 0 });
  
    if (contentSlide.length > 0) {
      this.timeline.fromTo(contentSlide, { yPercent: 0 }, { duration: this.shouldAnimate ? 0.4 : 0, yPercent: 100, ease: Cubic.easeIn }, 0);
    }
  
    if (contentFade.length > 0) {
      this.timeline.fromTo(contentFade, { autoAlpha: 1, y: 0 }, { duration: this.shouldAnimate ? 0.4 : 0, autoAlpha: 0, y: 30, ease: Cubic.easeIn }, 0);
    }

    if (buttonWrapper) {
      this.timeline.fromTo(buttonWrapper, this.shouldAnimate ? 0.4 : 0, { autoAlpha: 1, y: 0 }, { autoAlpha: 0, y: 10, ease: Cubic.easeIn }, 0);
    }
  }
  _slideEnter(slide) {
    let images = slide.querySelectorAll('.slideshow__image'),
        content = slide.querySelectorAll('.sectionHeader'),
        contentSlide = slide.querySelectorAll('.sectionHeader__subHeading span'),
        contentFade = slide.querySelectorAll('.sectionHeader__heading'),
        buttonWrapper = slide.querySelector('.sectionHeader__buttonWrapper');
    if (this.slideshow.flickityInstance.options.autoPlay && this.slideshow.flickityInstance.player.state === 'paused') {
      this.slideshow.flickityInstance.unpausePlayer();
    }

    if (window.CSS && window.CSS.supports('(object-fit: cover) or (-o-object-fit: cover)')) {
      if (window.theme.showImageZooming) {
        this.timeline.fromTo(images, this.shouldAnimate ? 1.2 : 0, { opacity: 0, scale: 1.2 }, { opacity: 1, scale: 1, ease: Quad.easeOut }, 'enter');
      } else {
        this.timeline.fromTo(images, this.shouldAnimate ? 1.2 : 0, { opacity: 0 }, { opacity: 1, ease: Quad.easeOut }, 'enter');
      }
    }
  
    if (content) {
      this.timeline.to(content, { autoAlpha: 1 }, 'enter');
    }
  
    if (contentSlide.length > 0) {
      this.timeline.fromTo(contentSlide, { yPercent: 100 }, { duration: this.shouldAnimate ? 0.8 : 0, yPercent: 0, delay: this.shouldAnimate ? 0.8 : 0, ease: Cubic.easeOut }, 'enter');
    }
  
    if (contentFade.length > 0) {
      this.timeline.fromTo(contentFade, { autoAlpha: 0, y: 30 }, { duration: this.shouldAnimate ? 0.8 : 0, autoAlpha: 1, y: 0, delay: this.shouldAnimate ? 0.95 : 0, ease: Cubic.easeOut }, 'enter');
    }

    if (buttonWrapper) {
      this.timeline.fromTo(buttonWrapper, this.shouldAnimate ? 0.8 : 0, { autoAlpha: 0, y: 20 }, { autoAlpha: 1, y: 0, delay: this.shouldAnimate ? 0.8 : 0, ease: Cubic.easeOut }, 'enter');
    }
    var contentPosition = this.slideshow.element.querySelector('.is-selected .slideshow__content');
    if(this.slideshow.element.classList.contains('slideshow__carousel--alt')){
      if(contentPosition.classList.contains('slideshow__content--bottomLeft')){
        setTimeout(() => {
          this.slideshow.element.classList.add('bottomLeft');
          this.slideshow.element.classList.remove('bottomRight');
          this.slideshow.element.classList.remove('bottomCenter');
        }, 350);
      }
      else if(contentPosition.classList.contains('slideshow__content--bottomCenter')){
        setTimeout(() => {
          this.slideshow.element.classList.add('bottomCenter');
          this.slideshow.element.classList.remove('bottomLeft');
          this.slideshow.element.classList.remove('bottomRight');
        }, 350);
      }
      else if(contentPosition.classList.contains('slideshow__content--bottomRight')){
        setTimeout(() => {
          this.slideshow.element.classList.add('bottomRight');
          this.slideshow.element.classList.remove('bottomLeft');
          this.slideshow.element.classList.remove('bottomCenter');
        }, 350);
      }
    }
  }
  _lazyLoadNextImage() {
    var currentIndex = this.slideshow.flickityInstance.selectedIndex,
        breakpoint = Responsive.getCurrentBreakpoint();

    if (this.slideshow.flickityInstance.cells.length - 1 > currentIndex) {
      var nextCellElement = this.slideshow.flickityInstance.cells[currentIndex + 1].element,
          imageContainers = Dom.nodeListToArray(nextCellElement.querySelectorAll('.slideshow__imageContainer')),
          imageToReveal = null;

      if (breakpoint === 'phone') {
        imageToReveal = imageContainers[0];
      } else {
        imageToReveal = imageContainers[1];
      }

      if (window.lazySizes && imageToReveal && imageToReveal.classList.contains('image--lazyLoad')) {
        lazySizes.loader.unveil(imageToReveal.firstElementChild);
      }
    }
  }
  _onBreakpointChanged(event) {
      this.selectedSlide = null;
      this._transitionToSlide(this.slideshow.flickityInstance.selectedElement);
  }
}